import type { RowVariantDefinition } from '@/deskUiSkeletons/rowTemplates/RowTemplateTypes'
import { defineRowVariantRegistry } from '@/deskUiSkeletons/rowTemplates/RowVariantRegistry'
import { sharedChatAnswerVariant } from '@/msgComponents/rowVariants/Chat/Chat'
import { DenseTemplate } from '@/msgComponents/rowVariants/Dense/Dense'
import { productRowVariantForPath, productRowVariantsForPath } from '../../../productDisplayCatalog'

const portalResultVariant = {
  ...productRowVariantForPath('portal', 1),
  Template: DenseTemplate,
} as const satisfies RowVariantDefinition

const productRows = productRowVariantsForPath('portal')

export const rowVariantRegistry = defineRowVariantRegistry({
  answers: {
    variants: [portalResultVariant, sharedChatAnswerVariant],
    fallback: productRows.answers.fallback,
  },
  submsges: {
    variants: [portalResultVariant],
    fallback: productRows.submsges.fallback,
  },
})
